// extracted by mini-css-extract-plugin
export default {"holidayBanner":"rrEMAQGf7xAhhnQMmaNS"};